import { render } from "./TheTip.vue?vue&type=template&id=30f6b34e&scoped=true"
import script from "./TheTip.vue?vue&type=script&lang=js"
export * from "./TheTip.vue?vue&type=script&lang=js"

import "./TheTip.vue?vue&type=style&index=0&id=30f6b34e&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f6b34e"]])

export default __exports__